var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcMonitored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.432L8 12.432L12.5 7.932M17 10.932C17 15.8404 11.646 19.4104 9.69799 20.5469C9.4766 20.676 9.3659 20.7406 9.20968 20.7741C9.08844 20.8001 8.91156 20.8001 8.79032 20.7741C8.6341 20.7406 8.5234 20.676 8.30201 20.5469C6.35396 19.4104 1 15.8404 1 10.932V6.1496C1 5.35009 1 4.95033 1.13076 4.6067C1.24627 4.30314 1.43398 4.03228 1.67766 3.81753C1.9535 3.57444 2.3278 3.43408 3.0764 3.15335L8.4382 1.14267C8.6461 1.06471 8.75005 1.02573 8.85698 1.01028C8.95184 0.996573 9.04816 0.996573 9.14302 1.01028C9.24995 1.02573 9.3539 1.06471 9.5618 1.14267L14.9236 3.15335C15.6722 3.43408 16.0465 3.57444 16.3223 3.81753C16.566 4.03228 16.7537 4.30314 16.8692 4.6067C17 4.95033 17 5.35009 17 6.1496V10.932Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcMonitored);
export default __webpack_public_path__ + "static/media/pc-monitored.a64dca77edaa97c1b42d3b6f642ae7ad.svg";
export { ForwardRef as ReactComponent };